import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'allowVerificationEmailEdit',
  initialState: true,
  reducers: {
    setAllowVerificationEmailEdit(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setAllowVerificationEmailEdit } = slice.actions;

export default slice.reducer;
